import React from "react";

export const removeBookmarkIcon = (
  <svg
    aria-hidden="true"
    role="img"
    width="32"
    height="32"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
  >
    <g fill="currentColor">
      <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
    </g>
  </svg>
);
export const bookmarkIcon = (
  <svg
    aria-hidden="true"
    role="img"
    width="32"
    height="32"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 16 16"
  >
    <g fill="currentColor">
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
    </g>
  </svg>
);

export const expandIcon = (
  <svg
    aria-hidden="true"
    height="32"
    viewBox="0 0 16 16"
    preserveAspectRatio="xMidYMid meet"
    version="1.1"
    width="32"
    role="img"
    data-view-component="true"
    className="octicon octicon-triangle-down v-align-middle stroy"
  >
    <path
      fill="currentColor"
      d="M4.427 7.427l3.396 3.396a.25.25 0 00.354 0l3.396-3.396A.25.25 0 0011.396 7H4.604a.25.25 0 00-.177.427z"
    ></path>
  </svg>
);
export const clearSearchIcon = (
  <svg
    aria-hidden="true"
    role="img"
    width="18"
    height="18"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29l-4.3 4.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l4.29-4.3l4.29 4.3a1 1 0 0 0 1.42 0a1 1 0 0 0 0-1.42z"
    />
  </svg>
);

export const goToTopIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fill="currentColor"
      d="M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0a.996.996 0 0 0 0-1.41l-6.59-6.59a.996.996 0 0 0-1.41 0l-6.6 6.58a.996.996 0 1 0 1.41 1.41L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1z"
    />
  </svg>
);

export const alertIcon = (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.667 18H15.3337V20.6667H12.667V18ZM12.667 7.33333H15.3337V15.3333H12.667V7.33333ZM13.987 0.666664C6.62699 0.666664 0.666992 6.64 0.666992 14C0.666992 21.36 6.62699 27.3333 13.987 27.3333C21.3603 27.3333 27.3337 21.36 27.3337 14C27.3337 6.64 21.3603 0.666664 13.987 0.666664ZM14.0003 24.6667C8.10699 24.6667 3.33366 19.8933 3.33366 14C3.33366 8.10666 8.10699 3.33333 14.0003 3.33333C19.8937 3.33333 24.667 8.10666 24.667 14C24.667 19.8933 19.8937 24.6667 14.0003 24.6667Z"
      fill="#8FFFAB"
    />
  </svg>
);

export const backArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m10.875 19.3l-6.6-6.6q-.15-.15-.213-.325Q4 12.2 4 12t.062-.375q.063-.175.213-.325l6.6-6.6q.275-.275.687-.288q.413-.012.713.288q.3.275.313.687q.012.413-.288.713L7.4 11h11.175q.425 0 .713.287q.287.288.287.713t-.287.712Q19 13 18.575 13H7.4l4.9 4.9q.275.275.288.7q.012.425-.288.7q-.275.3-.7.3q-.425 0-.725-.3Z"
    />
  </svg>
);
